import Phaser from 'phaser';
import SauceSquirtPoints from './SauceSquirtPoints';

export default class SaucePainter extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,viewPositions) {
    super(scene);

    this.viewPositions = viewPositions;

    this.hasPainted = false;

    this.selectedColor = '#c97f27';

    this.viewRect = {
      top: this.viewPositions.top,
      left: this.viewPositions.left,
      bottom: this.viewPositions.bottom,
      right: this.viewPositions.right,
      width: this.viewPositions.right - this.viewPositions.left,
      height: this.viewPositions.bottom - this.viewPositions.top
    };

    this.currentPainter = null;

    /** @type {SauceSquirtPoints[]} */
    this.painters = [];

    if (this.scene.textures.exists('saucepainter')) this.scene.textures.remove('saucepainter');
    this.fullMask = this.scene.textures.createCanvas('saucepainter', this.scene.scale.width, this.scene.scale.height);
  }

  startSquirt (x,y) {
    if (this.scene.textures.exists('startsquirt')) {
      this.paintShape = this.scene.textures.get('startsquirt');
    }
    else this.paintShape = this.scene.textures.createCanvas('startsquirt', this.scene.scale.width, this.scene.scale.height);

    this.paintShapeImage = this.scene.add.image(0,0,'startsquirt').setOrigin(0);
    this.add(this.paintShapeImage);

    this.currentPainter = new SauceSquirtPoints(this.paintShape, this.selectedColor, this.viewRect.bottom);
    this.currentPainter.addPoint(x,y);

    this.painters.push(this.currentPainter);
    this.hasPainted = true;
  }

  endSquirt () {
    this.currentPainter = null;
  }

  resetMask () {
    this.fullMask.clear();
  }

  addPoint (x,y) {
    this.currentPainter.addPoint(x,y);
  }

  cancelDrop() {
    this.painters = [];
    this.paintShape?.clear();
  }

  update (dt) {
    if (this.painters.length <= 0) {
      return null;
    }

    this.paintShape.clear();
    const ctx = this.fullMask.context;
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = 'black';

    for (let i = 0; i < this.painters.length; i++) {
      const thePainter = this.painters[i];
      const isDead = thePainter.update(dt);
      const paintCanvas = thePainter.render();
      ctx.drawImage(paintCanvas.canvas,0, 0, paintCanvas.width, paintCanvas.height, 0, 0, this.fullMask.width, this.fullMask.height);
      if (isDead) {
        Phaser.Utils.Array.RemoveAt(this.painters, i);
        i--;
      }
    }

    this.paintShape.refresh();
    this.fullMask.refresh();

    return this.fullMask;
  }
}